var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFormatSquare = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 25,
  height: 24,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  stroke: "#21241E"
}, /*#__PURE__*/React.createElement("path", {
  d: "M20.5 6.95v10.1A2.5 2.5 0 0 0 17.55 20H7.45q.048-.248.05-.5a2.5 2.5 0 0 0-3-2.45V6.95q.248.048.5.05a2.5 2.5 0 0 0 2.45-3h10.1a2.5 2.5 0 0 0 2.95 2.95Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.5 4.5a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0ZM22.5 4.5a2.5 2.5 0 1 1-3.983-2.016A2.5 2.5 0 0 1 22.5 4.5ZM7.5 19.5a2.5 2.5 0 1 1-4.998-.001 2.5 2.5 0 0 1 4.997.001ZM22.5 19.5a2.5 2.5 0 1 1-4.268-1.768A2.5 2.5 0 0 1 22.5 19.5Z"
}))));
export { SvgFormatSquare as ReactComponent };
export default __webpack_public_path__ + "47482aab7fd85d94682d61742c33a42b.svg";